



































































































































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHumanWithOutline from "@/common/components/icons/IconHumanWithOutline.vue";
import IconThanksMessage from "@/common/components/icons/IconThanksMessage.vue";
import IconNotification from "@/common/components/icons/IconNotification.vue";
import IconPointDefault from "@/common/components/icons/IconPointDefault.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import NaviItemLinkForSpOnGeneral from "@/common/components/organisms/header/general/NaviItemLinkForSpOnGeneral.vue";
import IconHeart from "@/common/components/icons/IconHeart.vue";
import IconOrderHistory from "@/common/components/icons/IconOrderHistory.vue";
import IconHistoryLog from "@/common/components/icons/IconHistoryLog.vue";
import IconMail from "@/common/components/icons/IconMail.vue";
import IconMypage from "@/common/components/icons/IconMypage.vue";

import { Vue, Component, Prop } from "vue-property-decorator";
import CONST_DATA from "@/general/mixins/const/constData";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import auth from "@/general/store/modules/auth";
@Component({
  name: "TheHeaderNaviOfUserMenu",
  components: {
    IconBase,
    IconHumanWithOutline,
    IconThanksMessage,
    IconNotification,
    IconPointDefault,
    IconHeart,
    IconOrderHistory,
    IconHistoryLog,
    IconMail,
    IconMypage,
    PointNotation,
    NaviItemLinkForSpOnGeneral
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  }
})
export default class TheHeaderNaviOfUserMenu extends Vue {
  @Prop({ type: Number, required: true }) point!: number;
  @Prop({ type: Object, required: true }) unit!: Record<string, any>;
  @Prop({ type: String, required: true }) iconColor!: string;
  @Prop({ type: Number, required: false, default: 0 })
  whatsNewUnreadCount!: number;
  @Prop({ type: Number, required: false, default: 0 })
  thanksPointUnreadCount!: number;

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get urls() {
    return {
      home: CONST_DATA.SITE_MAP.TOP_PAGE,
      point_confirmation: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,
      thanks_point: CONST_DATA.SITE_MAP.THANKS_POINT,
      whats_new: CONST_DATA.SITE_MAP.WHATS_NEW,
      favorites: process.env.VUE_APP_MYPAGE + '/favorites/',
      orders: process.env.VUE_APP_MYPAGE + '/orders',
      visit: process.env.VUE_APP_MYPAGE + '/visits/',
      mail_settings: CONST_DATA.SITE_MAP.MAIL_DELIVERY_SETTINGS,
      mypage: process.env.VUE_APP_MYPAGE
    };
  }

  get showMailSettings() {
    return (
      !auth.user.approval_result_notification_mail &&
      !auth.user.point_expiry_notification_enabled &&
      !auth.user.point_balance_notification_enabled &&
      !auth.user.point_receipt_notification_enabled &&
      !auth.user.mail_magazine_enabled
    );
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }
}
